export default "__VITE_ASSET__x4m5mu$r__"